import { Button, Card, Tag, Divider } from "antd";
import { useNavigate } from "react-router-dom";
import { BsShieldCheck, BsBuildings } from "react-icons/bs";
import { HiOutlineSparkles } from "react-icons/hi";
import Header from "../component/Home/Header";
import "./companyPortalLanding.css";

const benefits = [
  "One-click access to LMS, CRM, HRMS",
  "Community storytelling space",
  "Dedicated account success partner",
];

const workflow = [
  {
    title: "Register company",
    description: "Tell us who you are, upload brand assets, and invite your first admin team.",
  },
  {
    title: "Verify workspace",
    description: "Our team activates your workspace and maps the right services in under 24 hours.",
  },
  {
    title: "Launch services",
    description: "Unlock LMS, CRM, HRMS, and the public community hub from a single console.",
  },
];

export const CompanyPortalLanding = () => {
  const navigate = useNavigate();

  return (
    <div className="cplnd92-shell">
      <Header />
      <section className="cplnd92-hero">
        <div className="cplnd92-hero-content" style={{width:"64%"}}>
          <Tag icon={<BsShieldCheck size={14} />} color="blue">
            Enterprise-ready portal
          </Tag>
          <h1>Manage every company service from one modern console.</h1>
          <p>
            Launch training pathways, manage customer growth, streamline people ops, and narrate your brand story on the
            MetBrains community—without juggling multiple tools.
          </p>
          <div className="cplnd92-hero-actions">
            <Button type="primary" size="large" onClick={() => navigate("/company-portal/register")}
              icon={<HiOutlineSparkles size={18} />}
            >
              Register company
            </Button>
            <Button size="large" type="default" onClick={() => navigate("/login/company")}>
              Login as existing partner
            </Button>
          </div>
          <div className="cplnd92-badges">
            <span>99.9% uptime</span>
            <span>300+ enterprises onboarded</span>
            <span>24x7 relationship desk</span>
          </div>
        </div>
        {/* <div className="cplnd92-hero-card">
          <Card bordered={false} className="cplnd92-card">
            <div className="cplnd92-card-head">
              <BsBuildings size={28} />
              <div>
                <strong>Company Console</strong>
                <p>MetBrains enterprise services</p>
              </div>
            </div>
            <Divider />
            <ul>
              {benefits.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Button type="primary" block onClick={() => navigate("/company-portal/register")}>
              Create workspace
            </Button>
          </Card>
        </div> */}
      </section>

      {/* <section className="cplnd92-actions">
        <Card className="cplnd92-split" bordered={false}>
          <div>
            <p className="cplnd92-eyebrow">Get started in minutes</p>
            <h2>Two clear paths</h2>
            <p>
              Whether you need to set up a fresh workspace or access your existing dashboard, choose the option that fits and
              get going instantly.
            </p>
          </div>
          <div className="cplnd92-cta-grid">
            <Card className="cplnd92-option" bordered={false}>
              <h3>New to MetBrains?</h3>
              <p>Complete the verification-led registration and invite your leadership team.</p>
              <Button type="primary" onClick={() => navigate("/company-portal/register")}>
                Register company
              </Button>
            </Card>
            <Card className="cplnd92-option" bordered={false}>
              <h3>Already onboarded?</h3>
              <p>Jump straight into the unified console with your company credentials.</p>
              <Button onClick={() => navigate("/login/company")}>Go to login</Button>
            </Card>
          </div>
        </Card>
      </section> */}

      {/* <section className="cplnd92-workflow">
        <p className="cplnd92-eyebrow">What happens next</p>
        <h2>Onboarding clarity</h2>
        <div className="cplnd92-workflow-grid">
          {workflow.map((step, index) => (
            <Card key={step.title} bordered={false} className="cplnd92-workflow-card">
              <span>{index + 1}</span>
              <h4>{step.title}</h4>
              <p>{step.description}</p>
            </Card>
          ))}
        </div>
      </section> */}
    </div>
  );
};
